import ProhibitedUpload from './ProhibitedUpload'

const Container = ({ isVpn }: { isVpn: boolean }) => {
    return <ProhibitedUpload isFullHeight={false} isVpn={isVpn} />
}

export default Container
